import React from "react";
import { useSignUpForm } from "./SignUpFormContext";
import { useFormContext } from "react-hook-form";
import { SignUpFormData } from "../../SignUpFormTypes/signUpFormTypes";
import { removeValueFromPassword } from "./signUpHelpers";

const GoBackButton = () => {
  const { trigger, setValue } = useFormContext<SignUpFormData>();
  const { prev, currentStep, steps } = useSignUpForm();

  const handleBack = () => {
    prev();
    removeValueFromPassword(steps, currentStep, setValue, false);
    trigger();
    return;
  };

  return (
    <div className="flex justify-center items-center">
      <button
        style={{
          backgroundColor: "transparent",
          paddingLeft: "0",
          paddingRight: "0",
        }}
        className="cursor-pointer text-forest-900 text-base not-italic font-semibold leading-4 pb-[3.5px] !border-b-sun-600 !border-b-[1.5px]"
        onClick={handleBack}
      >
        Go back
      </button>
    </div>
  );
};

export default GoBackButton;
